<template>
  <div class="assetsCalculation">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">资产计提</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>计提时间</span>
            <el-date-picker
              v-model="startDate"
              type="month"
              size="small"
              :clearable="false"
              placeholder="选择月">
            </el-date-picker>
          </div>
          <div class="select-container-box"> 
            <el-button size="small"  type="info" plain  class="add" @click="proviston" v-if="isEdit">计提</el-button>
            <el-button size="small"  type="info" plain  class="query"  @click="search">查询</el-button>
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table
          :data="list"
          style="width:100%" 
          size="medium" 
          :span-method="objectSpanMethod"
          border
          >
            <i slot="empty" style="font-style:normal">该时间段暂无数据</i>
          <el-table-column
            prop="fishBaseName" 
            label="基地" 
            align="center"
            show-overflow-tooltip 
          >
          </el-table-column>
          <el-table-column 
          prop="assetName" 
          label="资产名称" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="oldTotalMonth" 
          label="总折旧月数" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="salvage" 
          label="残值率" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="nowProviston" 
          label="本期计提" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="oldProviston" 
          label="累计已计提(元)" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="worth" 
          label="净值" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
import checkPermission from "../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "assetsCalculation",
  mixins: [mixins],
  data() {
    return {
      isEdit: "",
      list: [],
      spanArr: [],
      startDate: new Date()
    };
  },
  //默认时间
  created() {
    const start = new Date();
    start.setDate(1);
    this.startDate = this.$timeformatDay(start);
  },
  mounted() {
    if (
      this.companyList.isQlwVersion == false ||
      this.companyList.isQlwVersion == null
    ) {
      let permission = this.loginUser.permissions.find(item => {
        return item.permissionId == this.permission.assetsCalculation;
      });
      if (permission) {
        this.isEdit = !permission.isReadOnly;
      }
    } else if (this.companyList.isQlwVersion == true) {
      checkPermission.checkEdit(this.$route).then(data => {
        this.isEdit = data;
      });
    }
    this.search();
  },
  methods: {
    ...mapActions(modules.costOriginValue, [
      "getAssetsCalculationList",
      "jiti"
    ]),
    //计提
    async proviston() {
      await this.jiti({
        provistonTime: this.$timeformatDay(this.startDate)
      })
        .then(data => {
          this.$message.success("计提成功");
          this.search();
        })
        .catch(err => {
          this.search();
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
        });
    },
    //查询
    async search() {
      await this.getAssetsCalculationList({
        provistonTime: this.$timeformatDay(this.startDate)
      })
        .then(data => {
          this.list = data;
          this.list.forEach(f => {
            f.nowProviston = f.nowProviston.toFixed(2);
            f.oldProviston = f.oldProviston.toFixed(2);
            f.worth = f.worth.toFixed(2);
          });
          if (this.list.length != 0) {
            this.rowSpan();
          }
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
        });
    },
    rowSpan() {
      let contactDot = 0;
      this.spanArr = [];
      this.list.forEach((item, index) => {
        item.index = index;
        if (index === 0) {
          this.spanArr.push(1);
        } else {
          if (item.fishBaseName === this.list[index - 1].fishBaseName) {
            this.spanArr[contactDot] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            contactDot = index;
          }
        }
      });
    },
    //合并相同基地
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    }
  }
};
</script>
<style lang="stylus" >
  .assetsCalculation
    .table-container
      .el-table::before
        width:100%!important
        border-bottom:0.5px solid #DDDDDD!important
      .el-table .el-table__body tbody td
        border-bottom 1px solid #DDD!important;
      .el-table .el-table__row:nth-of-type(even)
        background #fff !important;

</style>
